import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getEOCActive } from '../../../reducer/eocActiveSlice';
import { getProfile } from '../../../reducer/profileSlice';
import { setActivityActive } from '../../../reducer/activityActiveSlice';

function DeleteActivity({ open, setOpen, dataActivity }) {

    const dispatch = useDispatch();
    const eocActive = useSelector(getEOCActive);
    const profile = useSelector(getProfile);
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        getEOCActivity();
        setOpen(false);
        setStatus("");
    };

    const getEOCActivity = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_activity/${eocActive?.eoc_id}`
            );
            const data = await response.json();
            dispatch(setActivityActive(data));
        } catch (error) {
            console.log(error);
        }
    };

    const handleDeleteActivity = async () => {
        setLoading(true);
        try {
            let dataSend = {
                eoc_id: dataActivity?.eoc_id,
                activity_id: dataActivity?.activity_id,
                creator_id: eocActive?.creator_id,
                creator_name: eocActive?.creator_name,
                org_id: profile?.org_id,
                org_name: profile?.org_name,
                org_type: profile?.org_type,
                org_type_name: profile?.org_type_name,
                org_level: profile?.org_level,
                org_level_name: profile?.org_level_name,
                remark: "",
                phone: profile?.telephone,
                email: profile?.mail,
            };
            const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/delete_activity`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataSend),
            });
            if (response.ok) {
                setStatus("ทำการปิดกิจกรรมเสร็จสิ้น")
                setLoading(false);

            } else {
                setStatus("เกิดข้อผิดพลาด ไม่สามารถปิดกิจกรรมได้");
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setStatus("เกิดข้อผิดพลาด ไม่สามารถปิดกิจกรรมได้");
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Dialog
                maxWidth={'sm'}
                open={open}
            >
                <DialogContent>
                    {status === "" ? (
                        <Typography variant="body1">คุณยืนยันที่จะลบกิจกรรมหรือไม่</Typography>
                    ) : (
                        <Typography variant="body1">{status}</Typography>
                    )}
                </DialogContent>
                <DialogActions className='m-4 gap-1'>
                    {status === "" ? (
                        <>
                            <LoadingButton
                                loading={loading}
                                onClick={handleDeleteActivity}
                                variant="contained"
                                size='small'
                                style={{
                                    backgroundColor: "#cd6c4a",
                                }}
                            >
                                ยืนยัน
                            </LoadingButton>
                            <Button
                                onClick={handleClose}
                                variant="outlined"
                                size='small'
                                style={{
                                    color: "#000",
                                    borderColor: "#ccc",
                                }}
                            >
                                ยกเลิก
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                onClick={handleClose}
                                variant="outlined"
                                size='small'
                                style={{
                                    color: "#000",
                                    borderColor: "#ccc",
                                }}
                            >
                                ปิด
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}

export default DeleteActivity